/* Meirelle v6 - collection tiles (Birkenstock-like: name / descriptor / colour / price + colour swatches that swap the photo). Loaded from footer-group on collection pages. */
(function () {
  if (window.__mmPlp) return;
  window.__mmPlp = 1;

  function subOf(h) {
    if (/^maibulun-suede-sandal/.test(h)) return 'Two-strap footbed sandal';
    if (/^maibulun-leather-sandal/.test(h)) return 'Two-strap footbed sandal';
    if (/^clog/.test(h)) return 'Slip-on footbed clog';
    if (/^salerno/.test(h)) return 'Footbed sandal';
    return '';
  }

  function tiles() {
    var links = document.querySelectorAll('.product-card-wrapper .card__heading a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-mm')) continue;
      a.setAttribute('data-mm', '1');
      var handle = ((a.getAttribute('href') || '').split('/products/')[1] || '').split('?')[0];
      var parts = a.textContent.trim().split(' - ');
      if (parts.length < 2) continue;
      a.textContent = parts[0];
      var heading = a.closest('.card__heading') || a;
      var meta = document.createElement('p');
      meta.className = 'mm-card__meta';
      meta.textContent = subOf(handle);
      var col = document.createElement('p');
      col.className = 'mm-card__col';
      col.textContent = parts.slice(1).join(' - ');
      heading.parentNode.insertBefore(col, heading.nextSibling);
      heading.parentNode.insertBefore(meta, heading.nextSibling);
    }
  }

  /* ---------- colour swatches: one tile per model ---------- */
  var st = document.createElement('style');
  st.textContent =
    '.mm-sws{display:flex;flex-wrap:wrap;gap:4px;margin:8px 0 2px;position:relative;z-index:4}' +
    '.mm-sws__i,.mm-sws__more{box-sizing:border-box;width:26px;height:26px;padding:0;border:1px solid #d9d9d9;border-radius:50%;background:#f4f2ee;overflow:hidden;cursor:pointer;-webkit-appearance:none;appearance:none;position:relative}' +
    '.mm-sws__i img{display:block;width:100%;height:100%;object-fit:cover}' +
    '.mm-sws__i.is-cur{border-color:#fff;box-shadow:0 0 0 1.5px #111}' +
    '.mm-sws__i:focus-visible,.mm-sws__more:focus-visible{outline:2px solid #111;outline-offset:2px}' +
    '.mm-sws__more{background:#fff;font-size:11px;font-weight:700;color:#111;line-height:1}' +
    '.mm-sws:not(.is-open) .mm-sws__x{display:none}' +
    '.mm-grp .quick-add{display:none}';
  document.head.appendChild(st);

  var listP = null;
  function famOf(p) { return p.title.split(' - ')[0]; }
  function colOf(p) { return p.title.split(' - ').slice(1).join(' - '); }
  function loadList() {
    if (listP) return listP;
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (!m) return (listP = Promise.resolve([]));
    var s = location.search.match(/[?&]sort_by=([^&]+)/);
    listP = fetch('/collections/' + m[1] + '/products.json?limit=100' + (s ? '&sort_by=' + s[1] : ''), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { return j.products || []; })
      .catch(function () { listP = null; return []; });
    return listP;
  }

  function setImg(im, src, alt) {
    if (!im) return;
    if (!src) { im.style.display = 'none'; return; }
    var u = src.src, sep = u.indexOf('?') > -1 ? '&' : '?', w = [165, 360, 533, 720, 940];
    im.style.display = '';
    im.srcset = w.map(function (x) { return u + sep + 'width=' + x + ' ' + x + 'w'; }).join(', ');
    im.src = u + sep + 'width=533';
    im.alt = alt;
  }

  function swap(li, p) {
    var cn = colOf(p), alt = famOf(p) + ' - ' + cn;
    [].forEach.call(li.querySelectorAll('a[href*="/products/"]'), function (a) {
      a.setAttribute('href', a.getAttribute('href').replace(/\/products\/[^\/?#]+/, '/products/' + p.handle));
    });
    [].forEach.call(li.querySelectorAll('.mm-card__col'), function (e) { e.textContent = cn; });
    var ims = li.querySelectorAll('.card__media img');
    setImg(ims[0], p.images[0], alt);
    setImg(ims[1], p.images[1], '');
    [].forEach.call(li.querySelectorAll('.mm-sws__i'), function (b) {
      var on = b.getAttribute('data-h') === p.handle;
      b.classList.toggle('is-cur', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var lab = li.querySelector('.mm-sws');
    if (lab) lab.setAttribute('aria-label', 'Colour: ' + cn);
  }

  function build(li, prod, colours) {
    var info = [].filter.call(li.querySelectorAll('.card__information'), function (e) { return e.querySelector('.price'); })[0];
    if (!info) return;
    var box = document.createElement('div');
    box.className = 'mm-sws';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Colour: ' + colOf(prod));
    var idx = colours.indexOf(prod), extra = 0;
    colours.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mm-sws__i' + (p === prod ? ' is-cur' : '');
      if (i >= 4 && p !== prod) { b.className += ' mm-sws__x'; extra++; }
      b.title = colOf(p);
      b.setAttribute('aria-label', colOf(p));
      b.setAttribute('aria-pressed', p === prod ? 'true' : 'false');
      b.setAttribute('data-h', p.handle);
      var im = p.images && p.images[0];
      if (im) {
        var x = document.createElement('img');
        x.src = im.src + (im.src.indexOf('?') > -1 ? '&' : '?') + 'width=80';
        x.alt = '';
        x.loading = 'lazy';
        x.width = 26; x.height = 26;
        b.appendChild(x);
      }
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); swap(li, p); });
      box.appendChild(b);
    });
    if (extra) {
      var m = document.createElement('button');
      m.type = 'button';
      m.className = 'mm-sws__more';
      m.textContent = '+' + extra;
      m.setAttribute('aria-label', 'Show ' + extra + ' more colours');
      m.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); box.classList.add('is-open'); m.remove(); });
      box.appendChild(m);
    }
    info.insertBefore(box, info.firstChild);
    li.classList.add('mm-grp');
    setImg(li.querySelector('.card__media img'), prod.images[0], famOf(prod) + ' - ' + colOf(prod));
  }

  var filled = false;
  function hOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    return a ? ((a.getAttribute('href') || '').split('/products/')[1] || '').split('?')[0] : '';
  }
  /* other pages: bring in one tile per model that is not on this page yet, so a model is never missing */
  async function fill(pl, by, grid) {
    if (filled) return;
    filled = true;
    var pag = document.querySelector('.pagination-wrapper');
    if (!pag) return;
    var last = 1;
    [].forEach.call(pag.querySelectorAll('a[href*="page="]'), function (a) {
      var n = parseInt((a.getAttribute('href').match(/[?&]page=(\d+)/) || [])[1] || '1', 10);
      if (n > last) last = n;
    });
    var have = {};
    [].forEach.call(grid.children, function (li) { var p = by[hOf(li)]; if (p) have[famOf(p)] = 1; });
    for (var n = 2; n <= last; n++) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('page', n);
        var html = await fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); });
        var d = new DOMParser().parseFromString(html, 'text/html');
        [].forEach.call(d.querySelectorAll('#product-grid > li'), function (li) {
          var p = by[hOf(li)];
          if (p && !have[famOf(p)]) { have[famOf(p)] = 1; grid.appendChild(document.importNode(li, true)); }
        });
      } catch (e) {}
    }
  }

  async function group() {
    if (/[?&]filter\./.test(location.search)) return;
    var grid = document.querySelector('#product-grid');
    if (!grid || !grid.children.length) return;
    var pl = await loadList();
    if (!pl.length) return;
    var by = {}, fams = {};
    pl.forEach(function (p) { by[p.handle] = p; fams[famOf(p)] = 1; });
    if (Object.keys(fams).length < 2) return; /* single model: the colours are the choice, so show every colour as its own tile */
    var pg = parseInt((location.search.match(/[?&]page=(\d+)/) || [])[1] || '1', 10);
    if (pg > 1) { location.replace(location.pathname + location.search.replace(/([?&])page=\d+&?/, '$1').replace(/[?&]$/, '')); return; }
    await fill(pl, by, grid);
    var lis = [].slice.call(grid.children);
    var seen = {};
    lis.forEach(function (li) {
      var p = by[hOf(li)];
      if (!p) return;
      var f = famOf(p), cs = pl.filter(function (x) { return famOf(x) === f; });
      if (cs.length < 2) return;
      if (seen[f] && !li.querySelector('.mm-sws')) { li.style.display = 'none'; return; }
      seen[f] = 1;
      if (!li.querySelector('.mm-sws')) build(li, p, cs);
    });
    var all = Object.keys(fams).every(function (f) { return seen[f]; });
    if (all) {
      [].forEach.call(document.querySelectorAll('.pagination-wrapper'), function (e) { e.style.display = 'none'; });
      var nf = Object.keys(fams).length;
      var txt = nf + (nf === 1 ? ' model' : ' models') + ' · ' + pl.length + ' colours';
      [].forEach.call(document.querySelectorAll('#ProductCount, #ProductCountDesktop'), function (c) {
        var s = [].filter.call(c.querySelectorAll('span'), function (e) { return !e.children.length && /\d+\s+(products?|models?)/.test(e.textContent); })[0] || (/\d+\s+products?/.test(c.textContent) && !c.children.length ? c : null);
        if (s && s.textContent.trim() !== txt) s.textContent = txt;
      });
    }
  }

  /* UK spelling in the colour filter (Shopify's taxonomy label is "Gray") */
  function relabel() {
    [].forEach.call(document.querySelectorAll('[id*="Facet"],[class*="facet"]'), function (r) {
      var w = document.createTreeWalker(r, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) if (/\bGray\b/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\bGray\b/g, 'Grey');
    });
  }

  var t;
  function sched() {
    clearTimeout(t);
    t = setTimeout(function () { tiles(); relabel(); group().catch(function () {}); }, 60);
  }
  function go() { tiles(); relabel(); group().catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
  var g = document.querySelector('#ProductGridContainer') || document.querySelector('.product-grid-container') || document.body;
  new MutationObserver(sched).observe(g, { childList: true, subtree: true });
})();
